module.exports = __webpack_public_path__ + "svg/back.svg?4270c98c7b94accd111a9b2b4ebc4b75";